import { render, staticRenderFns } from "./Reg1.vue?vue&type=template&id=8dc8b638&scoped=true&"
import script from "./Reg1.vue?vue&type=script&lang=js&"
export * from "./Reg1.vue?vue&type=script&lang=js&"
import style0 from "./Reg1.vue?vue&type=style&index=0&id=8dc8b638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8b638",
  null
  
)

export default component.exports